// extracted by mini-css-extract-plugin
module.exports = {"titleblock":"titleblock_titleblock__2OK3r","titletext":"titleblock_titletext__3xdbG","titlelead":"titleblock_titlelead__1838T","morelink":"titleblock_morelink__25ZZL"};